<template>
  <div class="result-tip">

    <p v-if="resultType == -1">判定中<span class="ellipsis-container"></span></p>
    <p v-else-if="resultType == 0">
      <img src="@/assets/images/laba.png" @click="play" alt="" /><span class="result-true"
        style="font-size: 0.4rem;">纤维图案对比相符</span>
      <br />
      识别步骤2<br />
      揭开表层，手指甲可刮掉纤维<br />
      不符为假，右下角按钮可举报
    </p>
    <p v-else-if="resultType == 1">
      <img src="@/assets/images/laba.png" @click="play" alt="" /><span style="font-size: 0.4rem;">纤维图案对比不相符</span>
      <br />
      <span style="font-size: 0.5rem; line-height: 1.5rem;">为<span class="result-false">假冒产品</span></span>
      <br />
      <span style="font-size: 12px;">右下角按钮可举报</span>
      <!-- <span class="result-false">为假冒产品</span> -->
    </p>
    <p v-else-if="resultType == 2">
      扫描图片模糊<br />
      <span style="color: #2196f3">请重新扫描</span>
      <br />
      或按下图人工核对
    </p>
    <p v-else-if="resultType == 3">
      后台服务暂停<br />
      <br />
      请按下图人工核对
    </p>
    <p v-else-if="resultType == 4"><!-- 全由人工核对 -->
      <br />
      <br />
    </p>
    <p v-else-if="resultType == 5">
      <img src="@/assets/images/laba.png" @click="play" alt="" />
      <!-- <br /> -->
      <!-- 识别者按下图对比纤维图案 -->
      <br />
    </p>
    <audio ref="voideTrue" src="/static/voide/判真.mp3" controls="controls"></audio>
    <audio ref="voideFalse" src="/static/voide/判假.mp3" controls="controls"></audio>
    <audio ref="voide5" src="/static/voide/5.mp3" controls="controls"></audio>
  </div>
</template>

<script>
export default {
  props: {
    resultType: {
      type: Number,
      default: 0
    }
  },
  watch: {
    resultType: function (a, b) {
      if (a == 0) {
        this.$refs.voideTrue.play()
      } else if (a == 1) {
        this.$refs.voideFalse.play()
      } else if (a == 5) {
        this.$refs.voide5.play()
      }
    }
  },
  methods: {
    play() {
      if (this.resultType == 0) {
        this.$refs.voideTrue.play()
      } else if (this.resultType == 1) {
        this.$refs.voideFalse.play()
      } else if (this.resultType == 5) {
        this.$refs.voide5.play()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.result-tip {
  text-align: center;
  color: #3b3b3b;

  .ellipsis-container {
    position: relative;
    display: inline-block;
    width: 30px;
  }

  .ellipsis-container::after {
    content: '。。。';
    animation: ellipsis-dots 1.5s infinite;
  }

  @keyframes ellipsis-dots {

    0%,
    20%,
    100% {
      content: '';
    }

    25%,
    45% {
      content: '。';
    }

    50%,
    70% {
      content: '。。';
    }

    75%,
    95% {
      content: '。。。';
    }
  }

  img {
    width: 20px;
    padding: 5px;
    display: inline-block;
    vertical-align: middle;
    /* line-height: 20px; */
    margin-top: -3px !important;
  }

  audio {
    display: none;
  }

  p {
    font-size: 0.35rem;
    line-height: 0.6rem;

    .result-true {
      font-size: 0.5rem;
      line-height: 1rem;
    }

    .result-false {
      color: #ff5722;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Result/tip.vue